import { isMobile } from 'react-device-detect';

import {
    CONTENT_SECTION,
    INPUT_RECEIPT_NUMBER,
    INPUT_INVOICE_NUMBER,
    DATE_PICKER_SECTION,
    INPUT_INVOICE_RANDOM_NUMBER,
    FILE_UPLOAD_SECTION
} from 'config/formBasedSectionTypes';

export const einvoiceTypes = {
    EINVOICE: 1,
    EINVOICE_CARRIERS: 4,
    EINVOICE_QR_CODE_SCAN: 5
};

export const invoiceTypes = {
    INVOICE: 2,
    RECEIPT: 3,
    ...einvoiceTypes
};

export const sectionsOfInvoiceByType = {
    [invoiceTypes.EINVOICE]: new Set([
        CONTENT_SECTION,
        INPUT_INVOICE_NUMBER,
        DATE_PICKER_SECTION,
        INPUT_INVOICE_RANDOM_NUMBER
    ]),
    [invoiceTypes.EINVOICE_CARRIERS]: new Set([
        CONTENT_SECTION,
        INPUT_INVOICE_NUMBER,
        DATE_PICKER_SECTION
    ]),
    [invoiceTypes.INVOICE]: new Set([
        CONTENT_SECTION,
        INPUT_INVOICE_NUMBER,
        DATE_PICKER_SECTION,
        FILE_UPLOAD_SECTION
    ]),
    [invoiceTypes.RECEIPT]: new Set([
        CONTENT_SECTION,
        INPUT_RECEIPT_NUMBER,
        DATE_PICKER_SECTION,
        FILE_UPLOAD_SECTION
    ])
};

export const customFieldIds = {
    INVOICE_CARRIER_NUM: 'INVOICE_CARRIER_NUM',
    INVOICE_CARRIER_PASS: 'INVOICE_CARRIER_PASS'
};

export function convertInvocieTypeWhenCallAPI(type) {
    const m = {
        [invoiceTypes.EINVOICE_QR_CODE_SCAN]: invoiceTypes.EINVOICE
    };

    return m[type] ?? type;
}

// Ticket: https://app.clickup.com/t/3d8a7cb
export function convertInvoiceDefaultType(type) {
    const m = {
        [invoiceTypes.EINVOICE]: () =>
            isMobile ? invoiceTypes.EINVOICE_QR_CODE_SCAN : invoiceTypes.EINVOICE
    };

    return typeof m[type] === 'function' ? m[type]() : type;
}
